import { render, staticRenderFns } from "./EntidadPage.vue?vue&type=template&id=79f23f70"
import script from "./EntidadPage.js?vue&type=script&lang=js&external"
export * from "./EntidadPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports